import React from 'react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { auth } from './firebase';
import './Login.css';
import Fade from 'react-reveal/Fade';

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = e => {
        e.preventDefault();

        // firebase login
        auth.signInWithEmailAndPassword(email, password)
        .then(auth => {
            history.push('/')
        })
        .catch(error => alert(error.message))
    }

    const register = e => {
        e.preventDefault();

        // firebase register
        auth.createUserWithEmailAndPassword(email, password)
            .then((auth) =>{
                console.log(auth); //this means it worked fine
            if (auth) {
                history.push('/')
            } 
        })
        .catch(error => alert(error.message))
    }


    return (

        <div className="login">
            <Fade bottom>

            <Link to='/'>
            <img className="login_logo" src={window.location.origin + '/logo-b.png'} />
            </Link>
            <div className="login_container">
                <h1>Sign In</h1>

                <form>
                    <h5>E-mail</h5>
                    <input type='text' value={email} onChange={e => setEmail(e.target.value)}/>

                    <h5>Password</h5>
                    <input type='password' value={password} onChange={e => setPassword(e.target.value)}/>

                    <button className="login_signInButton" type='submit' onClick={signIn}>Sign In</button>
                </form>
                <p>
                    By signing-in you agree to the E-SHOP Conditions of Use & Sale. Please
                    see our Privacy Notice, our Cookies Notice and our Interest-Based Ads Notice.
                </p>

                <button onClick={register} className="login_registerButton">Create Account</button>
            </div>
            </Fade>
        </div>
    )
}

export default Login;
